<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent timeWidth">
      <el-row class="ListMenu">
        <el-col>
          <el-form ref="form" :model="listMenuForm" class="searchForm">
            <el-form-item style="width: 100px">
              <el-select
                v-model="listMenuForm.selectValue"
                placeholder="请选择"
                style="width: 100px !important;"
              >
                <el-option label="賬號" value="1"></el-option>
                <el-option label="暱稱" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="searchItem">
              <el-input
                v-model="listMenuForm.nickname"
                placeholder="在左側選擇搜索類別"
              ></el-input>
            </el-form-item>
            <el-form-item label="評論關鍵字">
              <el-input v-model="listMenuForm.context"></el-input>
            </el-form-item>
            <el-form-item label="評論狀態">
              <el-select
                v-model="listMenuForm.commentStatus"
                placeholder="请选择"
                @change="hidechange"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="未隱藏" value="1"></el-option>
                <el-option label="隱藏" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="隱藏選項"
              v-if="listMenuForm.commentStatus == 2"
              class="searchItem hidden-lg-and-down"
            >
              <el-select
                v-model="listMenuForm.feedbackStatus"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="黑名单" value="1"></el-option>
                <el-option label="违规" value="2"></el-option>
                <el-option label="敏感字符" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="評論時間"
              class="searchItem hidden-lg-and-down"
            >
              <el-date-picker
                v-model="listMenuForm.timeArr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row class="ListMenu">
        <el-col>
          <el-form
            ref="form"
            :model="listMenuForm"
            class="searchForm hidden-xl-only"
          >
            <el-form-item
              label="隱藏選項"
              v-if="listMenuForm.commentStatus == 2"
              class="searchItem"
            >
              <el-select
                v-model="listMenuForm.feedbackStatus"
                placeholder="请选择"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="黑名单" value="1"></el-option>
                <el-option label="违规" value="2"></el-option>
                <el-option label="敏感字符" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="評論時間" class="searchItem">
              <el-date-picker
                v-model="listMenuForm.timeArr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="MenuBtnWrap">
        <div class="btn" @click="search()">檢索用戶評論</div>
        <div class="btn borderBtn" @click="reset()">重置</div>
      </div>
      <div class="tableWrap">
        <el-table
          :data="comments"
          style="width:100%;"
          @selection-change="handleSelectionChange"
          ref="commentManagerTable"
        >
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column type="selection" min-width="55"> </el-table-column>
          <el-table-column prop="nickname" label="暱稱"> </el-table-column>
          <el-table-column prop="email" label="賬號" min-width="140">
          </el-table-column>
          <el-table-column prop="createDate" label="評論時間" min-width="160">
          </el-table-column>
          <el-table-column prop="context" label="評論內容" min-width="240">
          </el-table-column>
          <el-table-column prop="title" label="文章標題"> </el-table-column>
          <el-table-column prop="feedbackStatus" min-width="120" label="狀態">
          </el-table-column>
          <el-table-column prop="status" label="是否隱藏" min-width="70">
          </el-table-column>
          <el-table-column label="操作" fixed="right" :width="120">
            <template slot-scope="scope">
              <el-button
                @click="cancelHideComment(scope.row)"
                type="text"
                v-if="scope.row.status === '隱藏'"
                :disabled="
                  scope.row.feedbackStatus === '違規' ||
                    scope.row.feedbackStatus === '黑名單'
                "
                key="autoButton"
              >
                取消隱藏
              </el-button>
              <el-button @click="hideComment(scope.row)" type="text" v-else
                >隱藏
              </el-button>
              <el-button @click="delComment(scope.row)" type="text"
                >刪除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="table-operation">
        <div class="left-operation">
          <div class="el-table-column--selection">
            <div class="cell" style="width: 55px">
              <label class="el-checkbox">
                <span
                  aria-checked="mixed"
                  class="el-checkbox__input"
                  :class="selectStatus === 1 ? 'is-focus is-checked' : ''"
                  @click="selectAll"
                >
                  <span class="el-checkbox__inner"></span>
                </span>
              </label>
            </div>
          </div>
          <span class="font-color-29">全選</span>
        </div>
        <div class="right-operation">
          <div
            class="btn margin-left30"
            :class="selectStatus === 0 ? 'borderBtn' : ''"
            @click="hideComment('delselected')"
          >
            批量隐藏
          </div>
          <div
            class="btn margin-left30"
            :class="selectStatus === 0 ? 'borderBtn' : ''"
            @click="cancelHideComment('delselected')"
          >
            批量取消隐藏
          </div>
          <div
            class="btn margin-left30"
            :class="selectStatus === 0 ? 'borderBtn' : 'bg-delete-btn'"
            @click="delComment('delselected')"
          >
            刪除
          </div>
        </div>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="currentPageSize"
          :pager-count="5"
          layout="sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { getStatusHide } from "../../utils/getUserStatus";

export default {
  name: "comments",
  components: { NavBar, DiaMess },
  data() {
    return {
      navBlock: "靈魂的共鳴",
      navtitle: "評論管理",
      listMenuForm: {
        context: "",
        commentStatus: "",
        timeArr: [],
        selectValue: "0",
        nickname: "",
        feedbackStatus: ""
      },
      currentPage: 1,
      currentPageSize: 20,
      total: 50,
      delId: "",
      hideId: "",
      comments: [],
      dialogVisible: false,
      selectStatus: 0
    };
  },
  created() {
    let _this = this;
    _this.choiceTime();
  },
  methods: {
    // 最近90天
    choiceTime() {
      let _this = this;
      var endTime = new Date();
      var startTime = new Date();
      startTime = startTime.getTime() - 3600 * 1000 * 24 * 90;
      startTime = new Date(startTime);
      endTime = endTime;
      _this.listMenuForm.timeArr = [startTime, endTime];
      _this.initList();
    },
    // 初始化列表
    initList() {
      let _this = this;
      _this.selectStatus = 0;
      let param = {
        pageNo: _this.currentPage,
        pageSize: _this.currentPageSize,
        email:
          _this.listMenuForm.selectValue == 1
            ? _this.listMenuForm.nickname
            : "",
        nickName:
          _this.listMenuForm.selectValue == 0
            ? _this.listMenuForm.nickname
            : "",
        content: _this.listMenuForm.context,
        startTime:
          _this.listMenuForm.timeArr.length === 0
            ? ""
            : _this.$formatDate(_this.listMenuForm.timeArr[0]),
        endTime:
          _this.listMenuForm.timeArr.length === 0
            ? ""
            : _this
                .$formatDate(_this.listMenuForm.timeArr[1])
                .substring(0, 10) + " 23:59:59",
        hide: _this.listMenuForm.commentStatus
          ? Number(_this.listMenuForm.commentStatus)
          : "",
        feedbackStatus: _this.listMenuForm.feedbackStatus
          ? Number(_this.listMenuForm.feedbackStatus)
          : ""
      };
      _this
        .$post(
          `/request/soul/resonance/song/feedback/manage/list`,
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          console.log(res);
          if (res.code === "00000") {
            res.data.list.forEach(v => {
              v.createDate = _this.$getTime(v.createDate);
              v.feedbackStatus = getStatusHide(v.feedbackStatus);
              switch (v.status) {
                case 1:
                  v.status = "未隱藏";
                  break;
                case 2:
                  v.status = "隱藏";
                  break;
              }
            });
            _this.total = res.data.allRow;
            _this.comments = res.data.list;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },

    // 隐藏评论
    hideComment(row) {
      let _this = this;
      if (row === "delselected") {
        if (_this.delId === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請先選擇需要隱藏的評論", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else {
          let hideIds = [];
          _this.hideId.forEach((item) => {
              if (item.status == "未隱藏") {
                  hideIds.push(item.id);
              }
          });
          if (hideIds.length > 0) {
            _this
            .$confirm(
              `確認批量隱藏${_this.hideId.length}條評論，評論隱藏後將不在移動端與Web端展示！`,
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false
              }
            )
            .then(() => {
              let params = {
                  ids: hideIds,
                  type: 1
              }
              _this
                .$post(
                  `/request/soul/resonance/song/feedback/operation`,
                  params,
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  // console.log(res)
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage(
                      "批量隱藏評論成功",
                      "success",
                      function() {
                        _this.initList();
                        _this.dialogVisible = false;
                      }
                    );
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            });
          } else {
            this.$message({
                message: '當前所選評論已經全部隱藏',
                type: 'error',
                center: true
            });
          }
        }
      } else {
        _this
          .$confirm("是否隱藏該評論?", "提示信息", {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          })
          .then(() => {
            let params = {
              ids: [row.id],
              type: row.status === "未隱藏" ? 1 : 2
            }
            _this
              .$post(
                `/request/soul/resonance/song/feedback/operation`,
                params,
                _this.$GLOBAL.jsonConfig
              )
              .then(res => {
                // console.log(res)
                _this.dialogVisible = true;
                if (res.code === "00000") {
                  _this.$propMessage("隱藏成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.initList();
                  });
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          });
      }
    },

    // 批量取消隐藏评论
    cancelHideComment(row) {
      let _this = this;
      if (row === "delselected") {
        if (_this.delId === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請先選擇需要取消隱藏的評論", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else {
          let hideIds = [];
          _this.hideId.forEach((item) => {
              if (item.status == "隱藏") {
                  hideIds.push(item.id);
              }
          });
          if (hideIds.length > 0) {
            _this
            .$confirm(
              `確認批量取消隱藏${_this.hideId.length}條評論，評論取消隱藏後將在移動端與Web端重新展示！`,
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false
              }
            )
            .then(() => {
              let params = {
                  ids: hideIds,
                  type: 2
              }
              _this
                .$post(
                  `/request/soul/resonance/song/feedback/operation`,
                  params,
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage(
                      "批量取消隱藏評論成功",
                      "success",
                      function() {
                        _this.initList();
                        _this.dialogVisible = false;
                      }
                    );
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            });
          } else {
            this.$message({
                message: '當前所選評論已經全部取消隱藏',
                type: 'error',
                center: true
            });
          }
        }
      } else {
        _this
          .$confirm("是否取消隱藏該評論?", "提示信息", {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          })
          .then(() => {
            let params = {
              ids: [row.id],
              type: row.status === "未隱藏" ? 1 : 2
            }
            _this
              .$post(
                `/request/soul/resonance/song/feedback/operation`,
                params,
                _this.$GLOBAL.jsonConfig
              )
              .then(res => {
                console.log(res);
                _this.dialogVisible = true;
                if (res.code === "00000") {
                  _this.$propMessage("取消隱藏成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.initList();
                  });
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          });
      }
    },

    // 删除评论
    delComment(row) {
      let _this = this;
      if (row === "delselected") {
        if (_this.delId === "") {
          _this.dialogVisible = true;
          _this.$propMessage("請先選擇需要刪除的評論", "error", function() {
            _this.dialogVisible = false;
          });
          return false;
        } else {
          _this
            .$confirm(
              `確認批量刪除${_this.hideId.length}條評論，評論刪除後不可恢復！`,
              "提示信息",
              {
                confirmButtonText: "確認",
                cancelButtonText: "取消",
                center: true,
                closeOnClickModal: false
              }
            )
            .then(() => {
              let delIds = _this.delId.split(',');
              let params = {
                  ids: delIds,
              }
              _this
                .$post(
                  `/request/soul/resonance/song/batch/delete/feedback`,
                  params,
                  _this.$GLOBAL.jsonConfig
                )
                .then(res => {
                  _this.dialogVisible = true;
                  if (res.code === "00000") {
                    _this.$propMessage(
                      "批量删除評論成功",
                      "success",
                      function() {
                        _this.initList();
                        _this.dialogVisible = false;
                      }
                    );
                  } else {
                    _this.$propMessage(res.message, "error", function() {
                      _this.dialogVisible = false;
                    });
                  }
                });
            });
        }
      } else {
        _this
          .$confirm("是否刪除該評論?", "提示信息", {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false
          })
          .then(() => {
            // 确认删除的回调
            let params = {
              ids: [row.id],
            }
            _this
              .$post(
                `/request/soul/resonance/song/batch/delete/feedback`,
                params,
                _this.$GLOBAL.jsonConfig
              )
              .then(res => {
                _this.dialogVisible = true;
                if (res.code === "00000") {
                  _this.$propMessage("删除成功", "success", function() {
                    _this.dialogVisible = false;
                    _this.initList();
                  });
                } else {
                  _this.$propMessage(res.message, "error", function() {
                    _this.dialogVisible = false;
                  });
                }
              });
          });
      }
    },

    // 搜索
    search() {
      let _this = this;
      if (
        _this.listMenuForm.timeArr.length === 0 &&
        _this.listMenuForm.context === "" &&
        _this.listMenuForm.commentStatus === "" &&
        _this.listMenuForm.nickname === undefined
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入至少一個搜索條件", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      if (_this.$compareTime(_this.listMenuForm.timeArr[1], new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("結束時間不可以是未來時間", "error", function() {
          _this.dialogVisible = false;
        });
        return false;
      }
      _this.currentPage = 1;
      _this.initList();
    },

    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        timeArr: [],
        context: "",
        commentStatus: "",
        selectValue: "0",
        nickname: ""
      };
      _this.currentPage = 1;
      _this.initList();
    },

    // 選中的id
    handleSelectionChange(val) {
      let _this = this;
      let idArr = [];
      _this.hideId = [];
      if (val.length !== 0) {
        for (var i in val) {
          idArr.push(val[i].id);
          let temp = {};
          temp["id"] = val[i].id;
          temp["status"] = 1;
          _this.hideId.push(val[i]);
        }
      }
      _this.delId = idArr.join(",");
      if (val.length === 0) {
        this.selectStatus = 0;
      } else if (val.length === this.comments.length) {
        this.selectStatus = 1;
      } else {
        this.selectStatus = 2;
      }
    },

    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.initList();
    },

    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.initList();
    },

    // 全选按钮
    selectAll() {
      if (this.selectStatus === 0 || this.selectStatus === 2) {
        this.$refs.commentManagerTable.toggleAllSelection();
        this.selectStatus = 1;
      } else {
        this.$refs.commentManagerTable.clearSelection();
        this.selectStatus = 0;
      }
    },
    hidechange() {
      if (this.listMenuForm.commentStatus != "2") {
        this.listMenuForm.feedbackStatus = "";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 260px;
}
.el-table__header-wrapper .el-checkbox {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/jjsoul/comments.vue